import React from 'react';
import { FadeIn } from '../animations/FadeIn';

const steps = [
  {
    num: '01',
    title: 'Set up your medication',
    desc: 'Choose your specific GLP-1, starting dose, and preferred injection day.'
  },
  {
    num: '02',
    title: 'Log doses & weight',
    desc: 'Check off your weekly dose and quickly enter your weight when ready.'
  },
  {
    num: '03',
    title: 'See your trend',
    desc: 'Watch your progress unfold over time with clean, easy-to-read charts.'
  }
];

export const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <FadeIn className="mb-16">
          <h2 className="text-4xl font-semibold tracking-tight text-ink">How it works</h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-12 relative">
          {/* Connector line */}
          <div className="hidden md:block absolute top-[28px] left-[10%] right-[10%] h-px bg-gray-200"></div>

          {steps.map((step, index) => (
            <FadeIn key={index} delay={index * 0.2} className="relative z-10">
              <div className="w-14 h-14 rounded-full bg-paper border-4 border-white flex items-center justify-center text-lg font-semibold text-ink mb-6 shadow-sm">
                {step.num}
              </div>
              <h3 className="text-xl font-semibold mb-3 text-ink">{step.title}</h3>
              <p className="text-ink/70 leading-relaxed font-light">{step.desc}</p>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
};